import type { Exercice } from '@mairistem/comptabilite';
import { request } from '@mairistem/tools';

export const getExercices = (params: URLSearchParams) =>
	request.get<unknown, { data: Exercice[] }>(
		`/api/finances/comptabilite/parametrescomptabilites/exercices?all=true&${params?.toString()}`,
	);

export const getExercice = (id: number) =>
	request.get<unknown, Exercice>(
		`/api/finances/comptabilite/parametrescomptabilites/exercices/${id}?withEntite=true`,
	);
